import { SVGProps } from 'react';

function RangeArrowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="11" viewBox="0 0 24 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M17.716 1.46598V3.625H6.28405V1.46598C6.28405 0.463703 5.07228 -0.0382337 4.36353 0.670469L0.32952 4.70449C-0.10984 5.14384 -0.10984 5.85611 0.32952 6.29547L4.36353 10.3295C5.07224 11.0382 6.28405 10.5363 6.28405 9.53397V7.375H17.716V9.53402C17.716 10.5363 18.9278 11.0382 19.6365 10.3295L23.6706 6.29552C24.1099 5.85616 24.1099 5.14389 23.6706 4.70453L19.6365 0.670516C18.9278 -0.0382341 17.716 0.463703 17.716 1.46598Z" fill="#868991" />
    </svg>
  );
}

export default RangeArrowIcon;
